<!--------文件（需要鉴权）---------->
<template>
  <upload
    ref="upload"
    :file-id-before.sync="fileIdBeforeTemp"
    :group-id-before.sync="groupIdBeforeTemp"
    :props-data="{
      uploadMode: uploadMode,
      authorization: 1,
      onPreview: previewFile,
      onDownload: downloadFile,
      ...propsValue
    }"
    @change="fileList => $emit('change', fileList)"
  >
    <slot slot="btn" name="btn"></slot>
    <slot slot="tip" name="tip">
      <div class="important-tip m-l-10">
        支持pdf/doc/docx/xls/xlsx/ppt/pptx类型文件上传，单个文件最大50MB；其他类型文件单个最大200MB。最多上传{{
          propsValue.limit
        }}个。
      </div>
    </slot>
  </upload>
</template>

<script>
import Upload from '@/components/common/Upload'

export default {
  components: {
    Upload
  },

  model: {
    prop: 'attachmentGroupId',
    event: 'changeUploadId'
  },

  props: {
    uploadMode: {
      type: String,
      default: 'groupId'
    },
    attachmentGroupId: {
      type: [String, Number, Array],
      default: () => ''
    },

    // 需要上传给后端的数据
    requestParams: {
      type: Object,
      default: () => {}
    },

    // attachmentIdKey
    attachmentIdKey: {
      type: String,
      default: 'attachmentId'
    },

    // 后端返回的数据转换
    translateData: {
      type: Object,
      default: () => ({
        previewTranslate: {},
        downloadTranslate: 'biddingFileUrl'
      })
    },

    // 其他上传配置
    propsData: {
      type: Object,
      default: () => {}
    },

    previewApi: {
      type: Function,
      default: () => {}
    },
    downloadApi: {
      type: Function,
      default: () => {}
    }
  },

  data() {
    return {
      fileIdBeforeTemp: '',
      groupIdBeforeTemp: ''
    }
  },

  computed: {
    propsValue() {
      return {
        disabled: false,
        bizType: 'bidding_order',
        attachmentType: 'order_agreement_attachment',
        limit: 10,
        ...this.propsData
      }
    },

    requestParamsValue() {
      return {
        ...this.requestParams
      }
    }
  },

  watch: {
    attachmentGroupId: {
      handler: function(val) {
        if (this.uploadMode === 'groupId') {
          this.groupIdBeforeTemp = val || ''
        } else if (this.uploadMode === 'fileId') {
          this.fileIdBeforeTemp = val
        }
      },
      immediate: true
    },

    fileIdBeforeTemp(val) {
      this.$emit('changeUploadId', val)
    },

    groupIdBeforeTemp(val) {
      this.$emit('changeUploadId', val)
    }
  },

  methods: {
    /**
     * 判断是否上传完成
     */
    uploadComplete() {
      return this.$refs.upload.uploadComplete()
    },

    /**
     * @description: 图片预览和文件预览为两个不同的 接口
     * @param {*} fileId
     * @param {*} previewType
     * @return {*}
     */
    previewFile(fileId, previewType) {
      console.log('previewFile', fileId)
      console.log('previewType', previewType)
      const params = {
        pattern: 'read',
        [this.attachmentIdKey]: fileId,
        ...this.requestParamsValue
      }
      if (previewType === 'wpsPreview') {
        return new Promise((resolve, reject) => {
          this.previewApi(params)
            .then(res => {
              resolve(res)
            })
            .catch(err => {
              this.$message.error(err.message)
              reject()
            })
        })
      } else {
        return new Promise((resolve, reject) => {
          this.downloadApi({ ...params, isPreview: 1 })
            .then(res => {
              resolve(
                res.data[this.translateData?.downloadTranslate] || res.data
              )
            })
            .catch(err => {
              console.log('文件预览 err', err)
              this.$message.error(err.message)
              reject()
            })
        })
      }
    },

    /**
     * 下载文件
     */
    downloadFile(fileId) {
      const params = {
        [this.attachmentIdKey]: fileId,
        ...this.requestParamsValue
      }
      return new Promise((resolve, reject) => {
        this.downloadApi(params)
          .then(res => {
            resolve(res.data[this.translateData?.downloadTranslate] || res.data)
          })
          .catch(err => {
            this.$message.error(err.message || '下载附件失败')
            reject()
          })
      })
    }
  }
}
</script>
